import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { map, Observable, of } from 'rxjs';
import { UliLoadSearchModel } from './uli-load-search.model';
import { AddressModel } from '../../../../../../common';
import { filter, take } from 'rxjs/operators';

export function carrierValidator(form: AbstractControl): () => ValidationErrors {
  return () => {
    if (!form.get('carrierName')?.value) {
      return { required: true };
    }
    return null;
  };
}

export function duplicateLoadValidator(
  loadSearchResult$: Observable<UliLoadSearchModel>,
  isEnabledFn?: () => boolean,
): AsyncValidatorFn {
  return (control: AbstractControl) => {
    if (!control.value || isEnabledFn?.()) {
      return of(null);
    }

    return loadSearchResult$.pipe(
      filter((result: UliLoadSearchModel) => result?.loadNumber === control.value),
      take(1),
      map((result: UliLoadSearchModel) => (result?.exist ? { duplicateLoad: true } : null)),
    );
  };
}

export function addressSelectValidator(control: AbstractControl<AddressModel>): () => ValidationErrors {
  return () => {
    if (!control?.value?.fullAddress) {
      return { noOptionSelected: true };
    }
    return null;
  };
}

export function addressSearchResultValidator(addresses: AddressModel[]): () => ValidationErrors {
  return () => {
    if (addresses.length === 0) {
      return { noSearchResult: true };
    }
    return null;
  };
}
